import { Component, OnInit, OnDestroy, Output, Input, EventEmitter, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { routerTransition } from '../../../router.animations';
import { TranslateService } from '@ngx-translate/core';
import { BackendService } from 'src/app/services/backend.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/shared/format-datepicker';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss'],
    animations: [routerTransition()],
    providers: [
        {provide: DateAdapter, useClass: AppDateAdapter},
        {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
      ]
})
export class FormComponent implements OnInit, OnDestroy, AfterViewInit {
    error: boolean = false;
    errorMessage: String = "";
    dataLoading: boolean = false;
    private querySubscription;
    savedChanges: boolean = false;
    showform: boolean = false;
    showError: boolean = false;
    instituciones;
    institution;
    ide;
    lugares;
    guardar:boolean= true;
    options;
    place;
    diagnosis;
    estados;
    estudios;estudios1;
    ciudadano;
    idioma;
    usuarioActivo;
    admin;
    institucionesFinal;
    ano;dateDay;month;fecha;fecha1;ano1;dateDay1;month1;
    hasError = false;
    addPaciente = false;
    paciente_id=null;


    @Input() nextFormEvent:EventEmitter<any>;
    @Input() previousVersionEvent:EventEmitter<any>;
    @Output() sendFormEvent = new EventEmitter();
    @Output() pacienteSeleccionadoForm1 = new EventEmitter();
    @ViewChild('submitButton') submitButton:ElementRef;


    /*To cache the form in memory of browser */
    @Input() loadFormFromCache:EventEmitter<any>;
    @ViewChild('ciudadanoForm')ngForm: NgForm;
    formChangesSubscription: any;
    formSaved:any;
    xLengthPrevious: number = 0;
    xPrevious = null;

    name = 'Angular';
    value: any;

    constructor(private translate: TranslateService, private backendService: BackendService, private _route:Router) {
        this.translate.addLangs(['es', 'pt']);
        this.institucionesFinal=[];
        this.instituciones=[];
    }

    ngOnInit() {
        console.log("Cargando formulario 1");
        var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
        if (isSafari) alert("You are using safari, it is possible that the form does not work correctly, please try with another browser");

        if(localStorage.length<=0){
            this._route.navigate(['../login']);
        }
        else{
            if(localStorage.getItem('token')==null){
                this._route.navigate(['../login']);
            }
            else{
                this.showform=true;
                this.usuarioActivo=window.localStorage.getItem("entidad");
                this.admin = window.localStorage.getItem("admin");
                this.idioma=window.localStorage.getItem('idioma');
                this.ano= new Date().getFullYear();
                this.dateDay= new Date().getDate();
                this.month = new Date().getMonth()+1;
                this.fecha = this.dateDay + "/" + this.month + "/" + this.ano;
                this.ano1= new Date().getFullYear();
                this.dateDay1= new Date().getDate();
                this.month1 = new Date().getMonth()+1;
                this.fecha1 = this.dateDay1 + "/" + this.month1 + "/" + this.ano1;
            }
        }

        console.log("Event emiter de Form1")
        console.log(this.nextFormEvent);
        this.nextFormEvent.subscribe((e: any) => {
            console.log("Form1 ha recibido el evento de entregar el formulario");
            this.getFormulario();
        });
        console.log(this.loadFormFromCache);
        this.loadFormFromCache.subscribe((e: any) => {
            console.log("Form1 ha recibido el evento de cargar el formulario de cache");
            let form = e["form"];
            this.loadToFormFromCache(form);
        });

        console.log(this.previousVersionEvent);
        this.previousVersionEvent.subscribe((e: any) => {
            console.log("Form1 ha recibido el evento de cargar el formulario de version previa");
            let form = e["form"];
            //console.log(form);
            this.loadToFormFromPreviousVersion(form);
        });
    }

    loadToFormFromCache(form){
        if(form==null){
            form = {};
        }else{
            setTimeout(() => {
                form["id_paciente"] = null; //to avoid problems with patients selection
                this.ngForm.setValue(form);
            }, );
        }
    }

    ngAfterViewInit(){

        this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(x => {
            let xLength = Object.keys(x).length;
            console.log(xLength);
            console.log(this.xLengthPrevious);
            if(xLength==this.xLengthPrevious && JSON.stringify(x) !== JSON.stringify(this.xPrevious)){ //to discard changes due to add the fields to the form
                console.log(x);
                console.log("Cacheado");
                localStorage.setItem('ENCS1_FORM', JSON.stringify(x));
            } else{
                this.xLengthPrevious=xLength;
                this.xPrevious=x;
            }
        });
    }


    sleep (time) {
        return new Promise((resolve) => setTimeout(resolve, time));
      }



    reload(){
    }


    
    insertarSection1(formData, inputEvaluation_date){ 
        
        let vacio = false;
        if(inputEvaluation_date.value == null || inputEvaluation_date.value == "" ){
            console.log("evaluacion es nulo");
            vacio=true;
        }
        else{
            var evaluation= inputEvaluation_date.value.toString();
            if(evaluation.length==0){
                console.log("evaluacion es vacio");
                vacio=true;
            }
        }
        if(!vacio){
        console.log("ENCS-SECCIÓN 1 -----form.component.ts ----PASO POR: insertarSection1");
        this.hasError=false;
        this.dataLoading = true;
        this.showError=false;
        if (formData.inputEvaluation_date instanceof Date) {
            formData.inputEvaluation_date = this.formatDatePicker(formData.inputEvaluation_date);
        }
        console.log(formData);
        this.sendFormEvent.emit({"data":formData});
        }

    }

    getFormulario():void {
        let event = new MouseEvent('click', {bubbles: true});
        this.submitButton.nativeElement.dispatchEvent(event);

    }

    formatDatePicker(date){
        if(typeof date == 'string'){
            date = new Date(Date.parse(date));
            console.log(typeof date);
        }
        let day: string = date.getDate().toString();
        day = +day < 10 ? '0' + day : day;
        let month: string = (date.getMonth() + 1).toString();
        month = +month < 10 ? '0' + month : month;
        let year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }
     

    addingPaciente(event){
        if(event['bool']==false){
            this.addPaciente=false;
        }
        else{
            this.addPaciente=true;
        }
    }

    pacienteSeleccionado(event){
        this.addPaciente=false;
        this.paciente_id=event['id'];
        console.log("Paciente seleccionado");
        console.log(this.paciente_id);
        this.pacienteSeleccionadoForm1.emit({"id": this.paciente_id, "number":event["number"]});
    }


    loadToFormFromPreviousVersion(form){
        if(form==null){
            this.ngForm.reset({"id_paciente":this.ngForm.value["id_paciente"]});
        }else{
            setTimeout(() => {
                this.loadToFormFromPreviousVersionAux(form);
            }, );
        }
    }

    loadToFormFromPreviousVersionAux(data){
        delete data["id"];
        data["inputCode"] = data["codigo"];
        delete data["codigo"];
        data["inputEvaluation_date"] = data["evaluation_date"];
        delete data["evaluation_date"];

        console.log("Loading data in form1:");
        //console.log(data);
        this.ngForm.setValue(data);
    }

    ngOnDestroy(){
        if (this.querySubscription) {
          this.querySubscription.unsubscribe();
          this.institucionesFinal=[];
        }
    }

}
